import React, { useState, useEffect } from "react";
import CssCodeEditor from "../../../components/CssCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const StyleTab = ({ handleLayoutChange, selectedLayout,updateTeamShowcaseTabData,teamShowcaseTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [memberBackgroundColor, setMemberBackgroundColor] = useState(teamShowcaseTabData.member_background_color);
    const [textColor, setTextColor] = useState(teamShowcaseTabData.text_color);
    const [linksColor, setLinksColor] = useState(teamShowcaseTabData.links_color);
    const [callToActionButonColor, setCallToActionButonColor] = useState(teamShowcaseTabData.call_to_action_button_color);
    const [widgetBackgroundColor, setWidgetBackgroundColor] = useState(teamShowcaseTabData.widget_background_color);
    const [fontType, setFontType] = useState(teamShowcaseTabData.font_type);
    const [fontTypeDropdownOpen, setFontTypeDropdownOpen] = useState(false);
    const [activeWidgetAlignmentSection, setWidgetActiveAlignmentSection] = useState(teamShowcaseTabData.widget_align_type);
    const [widgetTitleColor, setWidgetTitleColor] = useState(teamShowcaseTabData.widget_title_color);
    const [widgetCaptionColor, setWidgetCaptionColor] = useState(teamShowcaseTabData.widget_caption_color);
    const [widgetLinksColor, setWidgetLinksColor] = useState(teamShowcaseTabData.widget_links_color);
    const [widgetTitleSize, setWidgetTitleSize] = useState(teamShowcaseTabData.widget_title_size);
    const [widgetTitleSizeDropdownOpen, setWidgetTitleSizeDropdownOpen] = useState(false);
    const [widgetCaptionSize, setWidgetCaptionSize] = useState(teamShowcaseTabData.widget_caption_size);
    const [widgetCaptionSizeDropdownOpen, setWidgetCaptionSizeDropdownOpen] = useState(false);
    const [popupBackgroundColor, setPopupBackgroundColor] = useState(teamShowcaseTabData.popup_background_color);
    const [popupTextColor, setPopupTextColor] = useState(teamShowcaseTabData.popup_text_color);
    const [popupLinksColor, setPopupLinksColor] = useState(teamShowcaseTabData.popup_links_color);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(teamShowcaseTabData.custom_css);

    // Handlers Member Background Color Change
    const handleMemberBackgroundColorChange = (color) => {
        setMemberBackgroundColor(color.hex);
        updateTeamShowcaseTabData("member_background_color", color.hex);
    };

    // Handlers Text Color Change
    const handleTextColorChange = (color) => {
        setTextColor(color.hex);
        updateTeamShowcaseTabData("text_color", color.hex);
    };

    // Handlers Links Color Change
    const handleLinksColorChange = (color) => {
        setLinksColor(color.hex);
        updateTeamShowcaseTabData("links_color", color.hex);
    };

    // Handlers Call To Action Button Color Change
    const handleCallToActionButonColorChange = (color) => {
        setCallToActionButonColor(color.hex);
        updateTeamShowcaseTabData("call_to_action_button_color", color.hex);
    };

    //Handlers Widget Background Color Change
    const handleWidgetBackgroundColorChange = (color) => {
        setWidgetBackgroundColor(color.hex);
        updateTeamShowcaseTabData("widget_background_color", color.hex);
    };

    // Handlers Font Type Change
    const handleFontTypeChange = (font) => {
        setFontType(font);
        updateTeamShowcaseTabData("font_type", font);
        setFontTypeDropdownOpen(false);
    };

    // Handlers Widget Title Color Change
    const handleWidgetTitleColorChange = (color) => {
        setWidgetTitleColor(color.hex);
        updateTeamShowcaseTabData("widget_title_color", color.hex);
    };

    // Handlers Widget Caption Color Change
    const handleWidgetCaptionColorChange = (color) => {
        setWidgetCaptionColor(color.hex);
        updateTeamShowcaseTabData("widget_caption_color", color.hex);
    };

    // Handlers Widget Links Color Change
    const handleWidgetLinksColorChange = (color) => {
        setWidgetLinksColor(color.hex);
        updateTeamShowcaseTabData("widget_links_color", color.hex);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateTeamShowcaseTabData("custom_css", code);
    };

    // Handle Position Widget Text Alignment Change
    const handleWidgetActiveAlignmentInputChange = (event) => {
        setWidgetActiveAlignmentSection(event.target.value);
        updateTeamShowcaseTabData("widget_align_type", event.target.value);
    };

    // Handlers Widget Title Size Change
    const handleWidgetTitleSizeChange = (font) => {
        setWidgetTitleSize(font);
        updateTeamShowcaseTabData("widget_title_size", font);
        setWidgetTitleSizeDropdownOpen(false);
    };

    // Handlers Widget Caption Size Change
    const handleWidgetCaptionSizeChange = (font) => {
        setWidgetCaptionSize(font);
        updateTeamShowcaseTabData("widget_caption_size", font);
        setWidgetCaptionSizeDropdownOpen(false);
    };
    // Handlers Popup Background Color Change
    const handlePopupBackgroundColorChange = (color) => {
        setPopupBackgroundColor(color.hex);
        updateTeamShowcaseTabData("popup_background_color", color.hex);
    };

    // Handlers Popup Text Color Change
    const handlePopupTextColorChange = (color) => {
        setPopupTextColor(color.hex);
        updateTeamShowcaseTabData("popup_text_color", color.hex);
    };

     // Handlers Popup Links Color Change
    const handlePopupLinksColorChange = (color) => {
        setPopupLinksColor(color.hex);
        updateTeamShowcaseTabData("popup_links_color", color.hex);
    };

    
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);
    
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Member Background Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={memberBackgroundColor} setColor={setMemberBackgroundColor} onChangeComplete={handleMemberBackgroundColorChange}/>
                            </div>
                        </div>

                        <div className="box-header-row">
                            <span>Text Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={textColor} setColor={setTextColor} onChangeComplete={handleTextColorChange}/>
                            </div>
                        </div>

                        <div className="box-header-row">
                            <span>Links Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={linksColor} setColor={setLinksColor} onChangeComplete={handleLinksColorChange}/>
                            </div>
                        </div>

                        <div className="box-header-row">
                            <span>Call to Action Button Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={callToActionButonColor} setColor={setCallToActionButonColor} onChangeComplete={handleCallToActionButonColorChange}/>
                            </div>
                        </div>

                        <div className="box-header-row">
                            <span>Font</span>
                            <div className="color-pikr-box" onClick={() => setFontTypeDropdownOpen(!fontTypeDropdownOpen)}>
                                <em>{fontType}</em>
                                {fontTypeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["Default"].map((font) => (
                                            <li key={font} onClick={() => handleFontTypeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("widget_background")}>Widget Background<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("widget_title")}>Widget Title<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("widget_popup")}>Popup<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "widget_background" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Widget Background</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Background</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={widgetBackgroundColor} setColor={setWidgetBackgroundColor} onChangeComplete={handleWidgetBackgroundColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "widget_title" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Widget Title</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Alignment</p>
                                <div className="left-cnater-right-button">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="left" onChange={handleWidgetActiveAlignmentInputChange} checked={activeWidgetAlignmentSection === "left"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Left</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="center" onChange={handleWidgetActiveAlignmentInputChange} checked={activeWidgetAlignmentSection === "center"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Center</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="alignment_type" className="card-input-element d-none" value="right" onChange={handleWidgetActiveAlignmentInputChange} checked={activeWidgetAlignmentSection === "right"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Right</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <p>Colors</p>
                            <div className="box-header-row">
                                <span>Title Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={widgetTitleColor} setColor={setWidgetTitleColor} onChangeComplete={handleWidgetTitleColorChange}/>
                                </div>
                            </div>

                             <div className="box-header-row">
                                <span>Caption Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={widgetCaptionColor} setColor={setWidgetCaptionColor} onChangeComplete={handleWidgetCaptionColorChange}/>
                                </div>
                            </div>

                             <div className="box-header-row">
                                <span>Links Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={widgetLinksColor} setColor={setWidgetLinksColor} onChangeComplete={handleWidgetLinksColorChange}/>
                                </div>
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <p>Fonts</p>
                            <div className="box-header-row">
                                <span>Title Size</span>
                                <div className="color-pikr-box" onClick={() => setWidgetTitleSizeDropdownOpen(!widgetTitleSizeDropdownOpen)}>
                                    <em>{widgetTitleSize}</em>
                                    {widgetTitleSizeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["10px","11px","12px","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                                <li key={font} onClick={() => handleWidgetTitleSizeChange(font)}>
                                                    {font}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <div className="box-header-row">
                                <span>Caption Size</span>
                                <div className="color-pikr-box" onClick={() => setWidgetCaptionSizeDropdownOpen(!widgetCaptionSizeDropdownOpen)}>
                                    <em>{widgetCaptionSize}</em>
                                    {widgetCaptionSizeDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["10px","11px","12px","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                                <li key={font} onClick={() => handleWidgetCaptionSizeChange(font)}>
                                                    {font}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "widget_popup" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Popup</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={popupBackgroundColor} setColor={setPopupBackgroundColor} onChangeComplete={handlePopupBackgroundColorChange}/>
                                </div>
                            </div>

                             <div className="box-header-row">
                                <span>Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={popupTextColor} setColor={setPopupTextColor} onChangeComplete={handlePopupTextColorChange}/>
                                </div>
                            </div>

                             <div className="box-header-row">
                                <span>Links Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={popupLinksColor} setColor={setPopupLinksColor} onChangeComplete={handlePopupLinksColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 
        </div>
    );
};

export default StyleTab;